import ja from './ja/translation';
import en from './en/translation';

const messages: Record<string, { translation: Record<string, string> }> = {
  ja: { translation: ja },
  en: { translation: en },
};

export default messages;